/* src/views/VoucherManagement.js */
import { ref, onMounted, toRaw } from 'vue'
import VoucherService from '../services/VoucherService'
import Swal from 'sweetalert2'

export default {
  name: 'VoucherManagement',
  
  setup() {

    const vouchers = ref([])
    const loading = ref(true)
    const isDrawerOpen = ref(false)
    const refundCode = ref('')
    const isCodeValid = ref(false)
    
    const loadVouchers = async () => {

      try {

        const response = await VoucherService.getVouchers()
        vouchers.value = response.data 
        console.debug("*** DEBUG: vouchers", toRaw(vouchers.value))
      } 
      catch (error) {
      
        console.error("Errore nel caricamento:", error)
      } 
      finally {
      
        loading.value = false
      }
    }

    const openDrawer = () => {
      isDrawerOpen.value = true
    }

    const closeDrawer = () => {
      isDrawerOpen.value = false
      refundCode.value = ''
      isCodeValid.value = false
    }


    const validateInput = () => {

      refundCode.value = refundCode.value.replace(/[^a-zA-Z0-9]/g, '')
      const regex = /^[a-zA-Z0-9]{8,12}$/
      isCodeValid.value = regex.test(refundCode.value)
    }

    const confirmRefund = async () => {

      if (!isCodeValid.value) return
      
      try {

        await VoucherService.refundVoucher(refundCode.value)
        Swal.fire({
            title: 'Successo',
            text: "Rimborso effettuato con successo!",
            icon: 'success',
            confirmButtonText: 'Chiudi'
        })
        closeDrawer()
        loadVouchers()
      } 
      catch (error) {

        const errorMessage = error.response?.data?.message || error.response?.data?.detail || "Codice non valido"
        Swal.fire({
            title: 'Errore',
            text: "Errore durante il rimborso: " + errorMessage,
            icon: 'error',
            confirmButtonText: 'Chiudi'
        })
      }
    }

    onMounted(loadVouchers)

    return { 
      vouchers, 
      loading, 
      isDrawerOpen,
      openDrawer,
      closeDrawer,
      refundCode, 
      isCodeValid, 
      validateInput, 
      confirmRefund 
    }
  }
}